import React from 'react'

import DuplicateAccountOptionsContainer from 'src/containers/Auth/DuplicateAccountOptions'

const DuplicateAccountOptionsPage: React.FC = () => {
  return <DuplicateAccountOptionsContainer />
}

export const PATH = '/duplicate-account' as const
export default DuplicateAccountOptionsPage
